module.exports = __webpack_public_path__ + "static/media/YellowHexagon.60a89190.svg";